import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class ConveniosService {

  constructor(
    private _apiService: ApiService
  ) { }

  GetConveniosListByEmpresaId(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getConveniosListByEmpresaId}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  GetNullAttributoEmpresa(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getNullAttributoEmpresa}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  GetNotNullAttributoEmpresa(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getNotNullAttributoEmpresa}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  GetNullAttributoEmpresaWithSelected(id: any, selected: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getNullAttributoEmpresaWithSelected}`;
    url = url.replace('{id}', id);
    url = url.replace('{selected}', selected);
    return this._apiService.get(url);
  }

  LoadAtributos(id: any, emprasaid: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.loadAtributos}`;
    url = url.replace('{id}', id);
    url = url.replace('{emprasaid}', emprasaid);
    return this._apiService.get(url);
  }

  GetAttributoEmpresa(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getAttributoEmpresa}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  AddConvenioAtributo(conveniosattributo: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addConvenioAtributo}`;
    return this._apiService.post(url, conveniosattributo);
  }

  UpdateConvenioAtributo(conveniosattributo: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateConvenioAtributo}`;
    return this._apiService.put(url, conveniosattributo);
  }

  DeleteConvenioAtributo(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteConvenioAtributo}`;
    url = url.replace('{id}', id);
    return this._apiService.delete(url);
  }
  DeleteConvenioAtributoRelacion(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteConvenioAtributoRelacion}`;
    url = url.replace('{id}', id);
    return this._apiService.delete(url);
  }

}
